import { render, staticRenderFns } from "./templateListModal.vue?vue&type=template&id=6a452a4e&scoped=true&"
import script from "./templateListModal.vue?vue&type=script&lang=js&"
export * from "./templateListModal.vue?vue&type=script&lang=js&"
import style0 from "./templateListModal.vue?vue&type=style&index=0&id=6a452a4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a452a4e",
  null
  
)

export default component.exports